export enum CTA_TYPE {
  PREORDER = 'PREORDER',
  ADD_TO_CART = 'ADD_TO_CART',
  WAITLIST = 'WAITLIST',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  SHOP_IN_THE_APP = 'SHOP_IN_THE_APP',
}

export const LOW_INVENTORY_THRESHOLD = 5
